import { SavedViews } from '@qualio/ui-components';

/**
 * Once an applied saved view matches the table state, the component library collapses the URL:
 * every filter, sort and search param is dropped and only this one is left behind. Anything
 * reading filters off the URL has to re-expand the view's `view_data` to see them.
 */
export const VIEW_ID_PARAM = 'view_id';

export const parseViewId = (raw: string | null): number | undefined => {
  if (!raw || !/^\d+$/.test(raw)) {
    return undefined;
  }
  const id = Number(raw);
  return Number.isSafeInteger(id) ? id : undefined;
};

/**
 * Re-expands a saved view's `view_data` into the search-param shape it was collapsed from.
 * `view_data` is keyed by filter name (plus `order_by`, `term` and `enabledColumns`), with
 * single-select filters held as a string and multi-selects as an array.
 */
export const viewDataToSearchParams = (viewData: SavedViews.ViewData): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(viewData).forEach(([key, value]) => {
    (Array.isArray(value) ? value : [value]).forEach((entry) => params.append(key, entry));
  });
  return params;
};
